import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class MobileService {
    private _isMobile = signal<boolean>(false)
    private _isMobileMenuOpen = signal<boolean>(false)

    public get(): Signal<boolean> {
        return this._isMobile
    }

    public set(value: boolean): void {
        this._isMobile.set(value)
    }

    public isMobileMenuOpen(): Signal<boolean> {
        return this._isMobileMenuOpen
    }

    public setIsMobileMenuOpen(value: boolean): void {
        this._isMobileMenuOpen.set(value)
    }
}
